<script>

let templateLacre = {id: null, numero: null, violado: false}

export default {
  name: 'LacresGrv',
  props: {
    lacres: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    adicionarLacre () {
      this.lacres.push(JSON.parse(JSON.stringify(templateLacre)))
    }
  }
}
</script>

<template>
  <div class="table-responsive">
    <table class="table table-hover table-bordered table-striped b-t b-light">
      <thead>
      <tr>
        <th colspan="2">Número</th>
        <th>Violado</th>
        <th>Apagar?</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="lacre in lacres">
        <td scope="row" width="25%" style="max-width: 25%; width: 25%">{{lacre.numero}}</td>
        <td scope="row"><input :id="lacre.id" v-model="lacre.numero" type="text" class="form-control"/>
        </td>
        <td scope="row">
          <label class="i-checks m-b-none">
            <input type="checkbox" :id="'violado-'+lacre.id" v-model="lacre.violado" tabindex="0"
                   aria-checked="false" aria-invalid="false"><i></i>
          </label>
        </td>
        <td scope="row" class="v-middle">
          <label class="i-switch bg-danger m-b-none">
            <input type="checkbox" :id="'del-'+lacre.id" tabindex="0" aria-checked="false"
                   aria-invalid="false" v-model="lacre.apagar"><i></i>
          </label>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="wrapper-sm m-t-n m-b">
      <button @click="adicionarLacre" type="button" class="btn btn-info btn-md m-l-xs btn-colsultaGrv">
        Adicionar outro lacre
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// LacresGrv.vue?4ea62f87